export default __webpack_public_path__ + "static/footer-img-79b3cfc0ceb3c7e466198ae09e1d4e6e.png";